module.exports = __webpack_public_path__ + "static/media/img4.2ff0f7d7.png";